import CONFIG from '@/config';

export const showGTM = () => {
  if (CONFIG.ENVIRONMENT !== 'development' && CONFIG.GTM?.length > 0) {
    return true;
  } else {
    return false;
  }
};
